var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarsSolid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.625C0 0.795312 0.638393 0.125 1.42857 0.125H18.5714C19.3616 0.125 20 0.795312 20 1.625C20 2.45469 19.3616 3.125 18.5714 3.125H1.42857C0.638393 3.125 0 2.45469 0 1.625ZM0 9.125C0 8.29531 0.638393 7.625 1.42857 7.625H18.5714C19.3616 7.625 20 8.29531 20 9.125C20 9.95469 19.3616 10.625 18.5714 10.625H1.42857C0.638393 10.625 0 9.95469 0 9.125ZM20 16.625C20 17.4547 19.3616 18.125 18.5714 18.125H1.42857C0.638393 18.125 0 17.4547 0 16.625C0 15.7953 0.638393 15.125 1.42857 15.125H18.5714C19.3616 15.125 20 15.7953 20 16.625Z",
    fill: "#1A2021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarsSolid);
export default __webpack_public_path__ + "static/media/bars-solid.cb36cb66d6887bca6996dc52edadf1c1.svg";
export { ForwardRef as ReactComponent };